export default function useSuccessToaster() {
  const toaster = useToaster()

  // TODO: figure out why this doesn't work
  const { t } = useI18n({
    messages: {
      en: { success: 'Success!' },
      nl: { success: 'Gelukt!' },
    },
  })

  const toast = ({ message, title }: { message: string, title?: string }) => {
    toaster.clearAll()

    toaster.show({
      title: title || t('success'),
      message: message,
      color: 'success',
      icon: 'ph:check',
      closable: true,
    })

    // Announce the toast to screen readers
    const announcement = t('success')
    const announcer = document.createElement('div')
    announcer.setAttribute('aria-live', 'polite')
    announcer.setAttribute('aria-atomic', 'true')
    announcer.className = 'sr-only'
    announcer.textContent = announcement
    document.body.appendChild(announcer)
  }

  return { toast }
}
